// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-3Il","col":"styles_col__2mMZ2"};